<template>
  <wizard-base class="assessment-value" :title="$t('WIZARD.ASSESSMENT_VALUE.TITLE')">
    <AssessmentValueBase :range-price="totalPrice">
      <template #action>
        <div class="assessment-value__footer columns is-centered">
          <HdButton class="column is-3" modifier="primary" @click="skipMarketingPrice()">{{
            $t('WIZARD.ASSESSMENT_VALUE.CTA')
          }}</HdButton>
        </div>
      </template>
      <template #footer>
        <div class="assessment-value__hint">
          <p v-html="$t('WIZARD.ASSESSMENT_VALUE.FOOTER_HINT')" />
        </div>
      </template>
    </AssessmentValueBase>
  </wizard-base>
</template>

<script>
// Components
import { HdButton } from 'homeday-blocks';
import WizardBase from '@/layout/WizardBase.vue';
import AssessmentValueBase from '@/views/wizard/AssessmentValueBase.vue';
// Constants
import { MUTATION, GETTER } from '@/store/CONSTANTS';

export default {
  name: 'AssessmentValue',
  components: {
    WizardBase,
    HdButton,
    AssessmentValueBase,
  },
  computed: {
    totalPrice() {
      return this.$store.getters[GETTER.WIZARD.CURRENT_DEAL.TOTAL_PRICE];
    },
  },
  created() {
    this.$store.commit(MUTATION.WIZARD.CURRENT_DEAL.SET_SKIP_SELLING_STRATEGY, false);
  },
  methods: {
    skipMarketingPrice() {
      this.$store.commit(
        MUTATION.WIZARD.CURRENT_DEAL.SET_MARKETING_PRICE,
        this.$store.getters[GETTER.WIZARD.CURRENT_DEAL.TOTAL_PRICE],
      );
      this.$store.commit(
        MUTATION.WIZARD.CURRENT_DEAL.SET_RECOMMENDED_STARTING_PRICE,
        this.$store.getters[GETTER.WIZARD.CURRENT_DEAL.TOTAL_PRICE],
      );
      this.$store.commit(MUTATION.WIZARD.CURRENT_DEAL.SET_SKIP_SELLING_STRATEGY, true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.assessment-value {
  &__hint {
    max-width: 700px;
    margin: $sp-xl auto 0;
    padding: $sp-l;
    display: flex;
    background-color: getShade($secondary-color, 70);
    border-radius: 8px;
  }
}
</style>
